import $ from 'jquery';
//Extends forms to add change tracking using jQuery Extensions.
$.fn.extend({
    // form object function Track Changes
    trackChanges: function () {
        // locate all inputs in the form and tack on a change event function
        $("input, textarea, select", this).on('change input', function () {
            let form: HTMLFormElement = (<HTMLInputElement>this).form;
            $(form).data("changed", true);
        });
    },
    hasChanged: function () {
        return this.data("changed");
    },
    resetChangeStatus: function () {
        let form: HTMLFormElement = (<HTMLInputElement>this).form;
        $(form).data("changed", false);
    }
});

// Field Utilities
export function addPhoneFormatterToKeyupEvent(id) {
    $('#' + id).on('keyup', function () {
        var unformattedPhone = $(this).val();
        $(this).val(formatPhoneNumber(unformattedPhone))
    });
}

export function fieldExists(id) {
    return $('#' + id).length > 0;
}

export function formatPhoneNumber(input) {
    //Remove all characters that are NOT hyphen, space, period, plus, left paren, right paren, zero through nine
    return input.replace(/[^- .+()0-9]/g, '');
}

export function isCountryDropdownInternationalValue(id) {
    return $('#' + id).children('option:selected').val() !== 'US' && $('#' + id).children('option:selected').val() !== 'CA';
}

//Sorting functions
export function sortByDate(dateA: Date, dateB: Date, sortDesc?: boolean): number {
    if (dateA > dateB) return sortDesc ? 1 : -1;
    if (dateA < dateB) return sortDesc ? -1 : 1;
    return 0;
}

export function sortString(stringA: string, stringB: string): number {
    return stringA.toUpperCase().localeCompare(stringB.toUpperCase());
}


//Date Parsing, turns .net's datetime format into ISO 8601 standard date format for javascript's Date() object.
export function parseDate(input): Date {
    if (input !== undefined) {
        let parts = input.match(/(\d+)/g);
        let month = parts[0] - 1; //months are 0-based
        let day = parts[1];
        let year = parts[2];
        let hour = parts[3]
        let minute = parts[4]
        let second = parts[5]
        return new Date(year, month, day, hour, minute, second);
    }
}

export function hasChangesOccurred() {
    let activeForm: string = $('#subLocationNav').children('a.active')[0].dataset.formId;
    return $('#' + activeForm).hasChanged();
}

export function preventAllEvents(event) {
    event.stopPropagation();
    event.preventDefault();
}

export function enableSave(target) {
    let formId: string = target.currentTarget.id;
    //Retrieve the forms save button and enable it.
    let element: any = ($('#' + formId).find('button.formSubmit'));
    element.removeAttr('disabled');
}

// performs password validation, used in registration page, account registration
export function pwdInputsValid(pwd1, pwd2) {
    const password = pwd1;
    const responseElement = "#pwdValidationError";
    $(responseElement).hide();
    $(responseElement).empty();

    if (password.length < 12) {
        $(responseElement).fadeIn();
        $(responseElement).append("<div class='alert alert-danger'>Your password is too short. Passwords must be at least 12 characters in length.</div>");
        return false;
    }

    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasNonalphas = /\W/.test(password);
    const hasConsecutiveCharacters = /(.)\1\1+/.test(password);

    if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasNonalphas || hasConsecutiveCharacters) {
        $(responseElement).fadeIn();
        let alertDiv = $("<div class='alert alert-danger'><p>Your password does not meet the minimum complexity requirements. Passwords must...</p></div>");
        let policyList = $("<ul>");
        policyList.append($("<li>").text("be at least 12 characters in length"));
        policyList.append($("<li>").text("have no more than 2 identical characters in a row"))
        policyList.append(
            $("<li>").text("contain at least 3 of the following")
                .append($("<ul>")
                    .append($("<li>").text("one uppercase letter"))
                    .append($("<li>").text("one lowercase letter"))
                    .append($("<li>").text("one number"))
                    .append($("<li>").text("one symbol"))
                )
        );
        alertDiv.append(policyList);
        $(responseElement).append(alertDiv);
        return false;
    }

    if (pwd1 !== pwd2) {
        $(responseElement).fadeIn();
        $(responseElement).append("<div class='alert alert-danger'>Your passwords do not match. Please try again.</div>");
        return false;
    }

    // all checks passed
    return true;
}
export function uniqueID() {
    return Math.floor(Math.random() * Date.now())
}
export function uniqueGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
export function getBaseURL() {
    var findCurrentURL = window.location;
    return findCurrentURL.protocol + "//" + findCurrentURL.host + "/";
}
export function getURLWithPath() {
    var findCurrentURL = window.location;
    return getBaseURL() + findCurrentURL.pathname.split('/')[1];
}
export function getLastItemOfPath() {

    return getURLWithPath().substring(getURLWithPath().lastIndexOf('/') + 1);
}